import React from 'react';
import * as util from "../../../other/util.js";
import FleetFormulas from "../../../share/formulas/fleet-formulas.js";
import FleetStep from "./fleet-step.js";
import ResourcesInput from "../../resources-input.js";
import ResourcesView from "../../resources-view.js";

export class PendingLoadFleetStep extends FleetStep {
    constructor() {
        super("LOAD");
    }

    doPreRenderPredictions(props, idx) {
        let loading_resources = props.task.resources;
        props.prediction.addEstimatedFuel(loading_resources.fuel);
    }

    render(props, idx) {
        let task = props.task;
        let planet = task.location;

        let space_port = (planet == null || planet.buildings == null) ? 0 : planet.buildings.space_port;
        let duration = FleetFormulas.getTimeForLoadingResources(task.resources, space_port);

        return (
            <div>
                <p className="boring-info-text">Loading</p>
                <ResourcesInput have={planet.resources} input={task.resources}
                    onChange={(resources) => this._onResourceChange(props, resources)} />
                <span>
                    <span className="boring-info-text">Time: </span>
                    <util.NiceInlineTimeSpan timeSpan={duration} />
                </span>
            </div>);
    }
}

export class FixedLoadFleetStep extends FleetStep {
    doPreRenderPredictions(props, idx) {
        let loading_resources = props.task.steps[idx].resources;
        props.prediction.addEstimatedFuel(loading_resources.fuel);
    }

    render(props, idx) {
        let task = props.task;
        let step = task.steps[idx];

        if (this._isStepDone(props, idx)) {
            return this._renderDone("Loading", idx);
        }

        let timer = (<util.NiceInlineTimeSpan timeSpan={step.duration} />);
        if (this.isStepActive(props, idx)) {
            timer = (<util.Timer date={step.finished} style={{ display: "inline" }} />);
        }

        return (
            <div>
                <p className="boring-info-text">Loading</p>
                <span>
                    <span className="boring-info-text">Time: </span>
                    {timer}
                </span>
                <ResourcesView resources={step.resources} />
            </div>);
    }
}